import * as Yup from 'yup';

const templateName = Yup.string()
  .trim()
  .min(1, 'Template name needs to have 1 character or more')
  .required('Template name is required');

export default templateName;
